  // src/components/PrimeirosAgendamento.jsx
  import React from "react";

  const tabelaStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: "10px"
  };
  const thTdStyle = {
    borderBottom: "1px solid #ddd",
    padding: "8px",
    textAlign: "left"
  };

  function PrimeirosAgendamento({ datasIndividuais = [], datasGrupos = [], loading }) {
    return (
      <div style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "30px",
        justifyContent: "center",
        margin: "20px 0",
      }}>
        {/* Tabela 1: Agendamento Individual */}
        <h2>Primeiros agendamentos disponíveis</h2>
        <div style={{ flex: 1, minWidth: "260px", maxWidth: "350px" }}>
          <h3 className="h4" style={{ textAlign: "center" }}>Individuais</h3>
          <table style={tabelaStyle}>
            <tbody>
              {loading ? (
                <tr><td colSpan={2}>Carregando...</td></tr>
              ) : (
                datasIndividuais.length > 0 ? datasIndividuais.map(({ consulado, data }, idx) => (
                  <tr key={idx}>
                    <td style={thTdStyle}>{consulado}</td>
                    <td style={{ ...thTdStyle, textAlign: "right" }}>{data}</td>
                  </tr>
                )) : (
                  <tr><td colSpan={2}>Nenhuma data disponível.</td></tr>
                )
              )}
            </tbody>
          </table>
        </div>
        {/* Tabela 2: Agendamento Grupo */}
        <div style={{ flex: 1, minWidth: "260px", maxWidth: "350px"}}>
          <h3 className="h4" style={{ textAlign: "center" }}>Grupos</h3>
          <table style={tabelaStyle}>
            <tbody>
              {loading ? (
                <tr><td colSpan={2}>Carregando...</td></tr>
              ) : (
                datasGrupos.length > 0 ? datasGrupos.map(({ consulado, data }, idx) => (
                  <tr key={idx}>
                    <td style={thTdStyle}>{consulado}</td>
                    <td style={{ ...thTdStyle, textAlign: "right" }}>{data}</td>
                  </tr>
                )) : (
                  <tr><td colSpan={2}>Nenhuma data disponível.</td></tr>
                )
              )}
            </tbody>
          </table>
        </div>
        {/* AVISO IMPORTANTE - uma só vez, centralizado */}
        <div style={{ width: "100%", marginTop: "10px", textAlign: "center" }}>
          <p style={{ fontWeight: "bold", color: "#bb520c" }}>
            Importante:{" "}
            <span style={{ fontWeight: "normal", color: "#222" }}>
              Observe que a disponibilidade de entrevistas muda continuamente devido ao agendamento por outros solicitantes.
            </span>
          </p>
        </div>
      </div>
    );
  }

  export default PrimeirosAgendamento;
